import { render, staticRenderFns } from "./MyButton.vue?vue&type=template&id=dd477406&scoped=true&"
import script from "./MyButton.vue?vue&type=script&lang=ts&"
export * from "./MyButton.vue?vue&type=script&lang=ts&"
import style0 from "./MyButton.vue?vue&type=style&index=0&id=dd477406&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd477406",
  null
  
)

export default component.exports